import "./styles.scss";

export function Footer() {
  return (
    <div className='footer'>
      <p>&copy;2021 Bizsys</p>
    </div>
  );
}
